import React, { useEffect, useState, useRef } from "react";
import "./Notification.css";

const Notification = ({
  message,
  type = "info",
  duration = 3000,
  onClose,
  actions = [],
  position = "top-center",
}) => {
  const [isExiting, setIsExiting] = useState(false);
  const onCloseRef = useRef();

  useEffect(() => {
    onCloseRef.current = onClose;
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => onCloseRef.current(), 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  // اگه duration = 0 باشه، خودکار بسته نشه
  if (duration === 0) {
    return (
      <div
        className={`notification ${type}`}
        onClick={(e) => e.stopPropagation()} // 👈 اضافه کن
        onMouseDown={(e) => e.stopPropagation()} // 👈 اضافه کن
        onMouseUp={(e) => e.stopPropagation()} // 👈 اضافه کن
      >
        {/* محتوا بدون تایمر */}
      </div>
    );
  }

  return (
    <div
      className={`notification ${type} ${isExiting ? "exit" : ""}`}
      onClick={(e) => e.stopPropagation()} // 👈 اضافه کن
      onMouseDown={(e) => e.stopPropagation()} // 👈 اضافه کن
      onMouseUp={(e) => e.stopPropagation()} // 👈 اضافه کن
    >
      <div className="notification-content">
        <div className="notification-icon">
          {type === "success" && "✓"}
          {type === "error" && "✕"}
          {type === "warning" && "⚠"}
          {type === "info" && "ℹ"}
        </div>
        <div className="notification-message">{message}</div>
        {actions.length > 0 && (
          <div className="notification-actions">
            {actions.map((action, index) => (
              <button
                key={index}
                className={`notification-action ${action.className || ""}`}
                onClick={() => {
                  action.onClick?.();
                  setIsExiting(true);
                  setTimeout(() => onCloseRef.current(), 300);
                }}
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
        <button
          className="notification-close"
          onClick={() => {
            setIsExiting(true);
            setTimeout(() => onCloseRef.current(), 300);
          }}
        >
          ✕
        </button>
      </div>
      <div
        className="notification-progress"
        style={{ animationDuration: `${duration}ms` }}
      />
    </div>
  );
};

export default Notification;
